// =========================
// Base value
// =========================
export type HomologationValue = string | number | boolean | null;

export interface HomologationsServiceInterface {
  apiUrl?: string | null;
}

// =========================
// PAIR
// =========================
export interface HomologationPair {
  origin: HomologationValue;
  destiny: HomologationValue;
}

// =========================
// ENTITY
// =========================
export interface HomologationItem {
  id: number;
  name: string;
  json_data: HomologationPair[];
  csv_file: string | null;
  created_at: string;
}

// =========================
// PAGINATED RESPONSE
// =========================
export interface PaginatedHomologationsResponse {
  data: Array<
    Omit<HomologationItem, 'json_data'> & {
      json_data: HomologationPair | HomologationPair[];
    }
  >;
  total: number;
  limit: number;
  page: number;
}

// =========================
// DTOs
// =========================
export interface HomologationCreateDTO {
  name: string;
  json_data: HomologationPair | HomologationPair[];
}

export interface HomologationUpdateDTO {
  name: string;
  json_data: HomologationPair | HomologationPair[];
}

// =========================
// SAVE EVENT
// =========================
export type HomologationSaveMode = 'manual' | 'import';

// =========================
// SAVE EVENTS (UI → CONTAINER)
// =========================

export type HomologationSaveEvent =
  | {
      mode: 'manual';
      id?: number;
      payload: {
        name: string;
        json_data: HomologationPair | HomologationPair[];
      };
    }
  | {
      mode: 'import';
      id?: number;
      payload: {
        name: string;
        file: File;
      };
    };
